import { DeleteRequest, GetRequest, PostRequest, PutRequest } from "./RequestTemplates";

export const createReminder = async (userId: string, reminder: Record<string, unknown>) => {
  return PostRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders`, reminder);
};

export const deleteReminder = async (userId: string, reminderIn: string) => {
  return DeleteRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders/${reminderIn}`);
};

export const getReminder = async (userId: string, reminderId: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders/${reminderId}`).then((res) => res.data);
};

export const updateReminder = async (userId: string, reminderId: string, data: object) => {
  return PutRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders/${reminderId}`, data);
};

export const getReminders = async (userId: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders`).then((res) => res.data);
};

export const getShortReminders = async (userId: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/users/${userId}/reminders?shortOffersOnly=true`).then(
    (res) => res.data
  );
};
